export function isStagingMode(): boolean {
  return window.location.hostname === 'staging.blissf.com'
}

const REVIEW_HOSTS = ['app.blissf.com', 'forexbrokereview.com', 'www.forexbrokereview.com']

export function isReviewMode(): boolean {
  return REVIEW_HOSTS.includes(window.location.hostname)
}

export function isForexReview(): boolean {
  return window.location.hostname.includes('forexbrokereview')
}

export const STAGING_ALLOWED_PATHS = [
  '/painel',
  '/paginas',
  '/engagement',
  '/broadcast',
  '/chat',
  '/login',
  '/configuracoes',
]

export const REVIEW_ALLOWED_PATHS = [
  '/gerenciador',
  '/broadcast',
  '/login',
]
